import React from "react";
import { Switch } from "antd";

const AppSwitch = ({
  checked,
  label,
  labelLeft,
  onChange,
  disabled = false,
  className = "",
  containerClassName = "",
  ...rest
}) => {
  const switchEl = (
    <Switch
      className={`app-switch ${className}`.trim()}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    />
  );

  return (
    <span className={`inline-flex max-w-full flex-nowrap items-center gap-2 ${containerClassName}`.trim()}>
      {labelLeft ? (
        <>
          <label className="m-0 shrink-0 whitespace-nowrap">{label}</label>
          {switchEl}
        </>
      ) : (
        <>
          {switchEl}
          <label className="m-0 shrink-0 whitespace-nowrap">{label}</label>
        </>
      )}
    </span>
  );
};

export default AppSwitch;
